import * as yup from "yup";
import { Model } from "@alphascriptsolutions/client-core";

export const tableSchema = yup
  .array()
  .test("is-table", "Should be at least 1 row added.", (value) => value.length !== 0)
  .required("Table value is required");

export const radioButtonSchema = yup
  .string()
  .test("is-radioButton", "Radio button cannot be empty", (value) => value !== "")
  .required("RadioButton is required");

export const checkBoxesSchema = yup
  .array()
  .test("is-table", "Should be at least 1 company selected.", (value) => value.length !== 0)
  .required("Company value is required");

export const contentLibrarySchema = yup
  .object()
  .shape({
    sharePricePerformanceLineChart: yup.boolean(),
    sharePricePerformanceColumnChart: yup.boolean(),
  })
  .test("object-sharePricePerformanceLineChart", "Please select at least one box", function (values) {
    const { sharePricePerformanceLineChart, sharePricePerformanceColumnChart } = values;
    return sharePricePerformanceLineChart || sharePricePerformanceColumnChart;
  });

export const initialInputPanelSchema = yup
  .object()
  .shape({
    companiesOnChartTable: tableSchema,
    timePeriodInitialInputs: yup
      .array()
      .test("is-timePeriodInitialInputs", "Time Range cannot be empty", (value) => value[0] !== "" && value[1] !== "")
      .required("Time Range is required"),
    currencySelectionSlot: yup
      .string()
      .test("is-radioCompanyNamesTimeSeries", "Currency must be selected", (value) => value !== "")
      .required("Currency is required"),
    percentageChangeChart: yup.boolean().optional(),
    actualTradedValueChart: yup.boolean().optional(),
    addCustomBuiltIndices: yup.boolean().optional(),
    noCustomBuiltIndices: yup.boolean().optional(),
    addConstantLineSelection: yup.boolean().optional(),
    noConstantLineSelection: yup.boolean().optional(),
  })
  .test("object-percentageChangeChart", "Please select at least one box", function (values) {
    const { percentageChangeChart, actualTradedValueChart } = values;
    return percentageChangeChart || actualTradedValueChart;
  })
  .test("object-addCustomBuiltIndices", "Please select at least one box", function (values) {
    const { addCustomBuiltIndices, noCustomBuiltIndices } = values;
    return addCustomBuiltIndices || noCustomBuiltIndices;
  })
  .test("object-addConstantLineSelection", "Please select at least one box", function (values) {
    const { addConstantLineSelection, noConstantLineSelection } = values;
    return addConstantLineSelection || noConstantLineSelection;
  });

export const IindexationPanelSchema = yup.object().shape({
  indexStartingPoint: yup
    .string()
    .test("is-radioButton", "Radio button cannot be empty", (value) => value !== "")
    .required("RadioButton is required"),
});

export const customBuildIndexesSchema = yup.object().shape({
  indexName: yup
    .string()
    .test("is-indexName", "Index name cannot be empty", (value) => value !== "")
    .required("Index name value is required"),
  constituentContributionApproach: yup
    .string()
    .test("is-constituentContributionApproach", "Index Type cannot be empty", (value) => value !== "")
    .required("Index Type is required"),
  defineIndexContituents: tableSchema,
  radioAddIndex: radioButtonSchema,
});

export const constantLineSchema = yup.object().shape({
  lineName: yup
    .string()
    .test("is-lineName", "Line name cannot be empty", (value) => value !== "")
    .required("Line name value is required"),
  calculationApproach: yup
    .string()
    .test("is-calculationApproach", "Approach cannot be is not selected", (value) => value !== "")
    .required("Approach is required"),
  radioAddLine: radioButtonSchema,
});

export const customizeOptionsPanelSchema = yup
  .object()
  .shape({
    addsummaryTable: yup.boolean().optional(),
    nosummaryTable: yup.boolean().optional(),
    addSmallLineChart: yup.boolean().optional(),
    nosmallLineChart: yup.boolean().optional(),
    addCallOutBoxes: yup.boolean().optional(),
    noCallOutBoxes: yup.boolean().optional(),
    addBackgroundShading: yup.boolean().optional(),
    noBackgroundShading: yup.boolean().optional(),
    addVerticalLine: yup.boolean().optional(),
    noVerticalLine: yup.boolean().optional(),
  })
  .test("object-addsummaryTable", "Please select at least one box", function (values) {
    const { addsummaryTable, nosummaryTable } = values;
    return addsummaryTable || nosummaryTable;
  })
  .test("object-addSmallLineChart", "Please select at least one box", function (values) {
    const { addSmallLineChart, nosmallLineChart } = values;
    return addSmallLineChart || nosmallLineChart;
  })
  .test("object-addCallOutBoxes", "Please select at least one box", function (values) {
    const { addCallOutBoxes, noCallOutBoxes } = values;
    return addCallOutBoxes || noCallOutBoxes;
  })
  .test("object-addBackgroundShading", "Please select at least one box", function (values) {
    const { addBackgroundShading, noBackgroundShading } = values;
    return addBackgroundShading || noBackgroundShading;
  })
  .test("object-addVerticalLine", "Please select at least one box", function (values) {
    const { addVerticalLine, noVerticalLine } = values;
    return addVerticalLine || noVerticalLine;
  });

export const summaryTablePanelSchema = yup.object().shape({
  checkboxCompaniesIncluded: checkBoxesSchema,
});

export const smallLineChartPanelSchema = yup.object().shape({
  smallLineChartTimePeriod: yup
    .array()
    .test("is-timePeriodInitialInputs", "Time Range cannot be empty", (value) => value[0] !== "" && value[1] !== "")
    .required("Time Range is required"),
  checkboxCompaniesIncludedSmallLine: checkBoxesSchema,
  customIndicesIncludedSmallLine: checkBoxesSchema,
  constantLinesIncludedSmallLine: checkBoxesSchema,
});

export const callOutBoxesPanelSchema = yup.object().shape({
  callOutBoxesTable: tableSchema,
});

export const backgroundShadingPanelSchema = yup.object().shape({
  shadingPeriodTable: tableSchema,
});

export const verticalLinePanelSchema = yup.object().shape({
  verticalLineTable: tableSchema,
});

export const formatTemplatesTablePanelSchema = yup.object().shape({
  companyName: yup
    .string()
    .test("is-selectButton", "Company Name cannot be empty", (value) => value !== "")
    .required("Company Name is required"),
  templateName: yup
    .string()
    .test("is-selectButton", "Template Name cannot be empty", (value) => value !== "")
    .required("Template Name is required"),
  // placeholderSelectionName: yup
  //   .string()
  //   .test("is-PlaceholderName", "Placeholder Name cannot be empty", (value) => value !== "")
  //   .required("Placeholder Name is required"),
});

export const companySharePriceCompaniesPanelSchema = yup.object().shape({
  companyNames: yup
    .string()
    .test("is-radioButton", "Radio button cannot be empty", (value) => value !== "")
    .required("RadioButton is required"),
});

export const valueIndexationPanelSchema = yup.object().shape({
  SelectedValue: yup
    .number()
    .typeError("Must be a valid number")
    .positive("Value must be greater than zero")
    .test("decimal-places", "Maximum of 2 decimal places allowed", (value) => {
      if (value === undefined || value === null) return false;

      const decimalCount = (value.toString().split(".")[1] || "").length;
      return decimalCount <= 2;
    })
    .required("Selected value is required"),
});

export function getIndexExtendedSchema(baseSchema: yup.ObjectSchema<any>, i: number) {
  return baseSchema.shape({
    ...baseSchema.fields,
    [`indexName${i + 1}`]: yup
      .string()
      .test("is-indexName", "Index name cannot be empty", (value) => !!value?.trim())
      .required("Index name value is required"),
    [`constituentContributionApproach${i + 1}`]: yup
      .string()
      .test("is-constituentContributionApproach", "Index Type cannot be empty", (value) => !!value?.trim())
      .required("Index Type is required"),
    [`defineIndexContituents${i + 1}`]: tableSchema,
    ...(i + 1 !== 4
      ? {
          [`radioAddIndex${i + 1}`]: radioButtonSchema,
        }
      : {}),
  });
}

export function getLineExtendedSchema(baseSchema: yup.ObjectSchema<any>, index: number) {
  return baseSchema.shape({
    ...baseSchema.fields,
    [`lineName${index + 1}`]: yup
      .string()
      .test("is-lineName", "Line name cannot be empty", (value) => value !== "")
      .required("Line name value is required"),
    [`calculationApproach${index + 1}`]: yup
      .string()
      .test("is-calculationApproach", "Approach cannot be is not selected", (value) => value !== "")
      .required("Approach is required"),
    ...(index + 1 !== 4
      ? {
          [`radioAddLine${index + 1}`]: radioButtonSchema,
        }
      : {}),
  });
}

export function getInputValueApproachSchema(baseSchema: yup.ObjectSchema<any>, index: number) {
  const suffix = index > 0 ? index : "";
  return baseSchema.shape({
    ...baseSchema.fields,
    [`InputvalueApprach${suffix}`]: yup
      .string()
      .test("is-InputvalueApprach", "Value cannot be empty", (value) => value !== "")
      .required("Value is required"),
  });
}

export function getDerivedDataCalculationApproachSchema(baseSchema: yup.ObjectSchema<any>, index: number) {
  const suffix = index > 0 ? index : "";
  return baseSchema.shape({
    ...baseSchema.fields,
    [`derivedDataCalculationApproach${suffix}`]: yup
      .string()
      .test("is-derivedDataCalculationApproach", "Value cannot be empty", (value) => value !== "")
      .required("Value is required"),
  });
}

export function getTimeSeriesSchema(baseSchema: yup.ObjectSchema<any>, index: number) {
  const suffix = index > 0 ? index : "";
  return baseSchema.shape({
    ...baseSchema.fields,
    [`timePeriodTimeSeries${suffix}`]: yup
      .array()
      .test(
        "is-timePeriodTimeSeries",
        "Time period cannot be empty",
        (value) => Array.isArray(value) && value[0] !== "" && value[1] !== ""
      )
      .required("Time period is required"),
    [`CalculationRadio${suffix}`]: yup
      .string()
      .test("is-CalculationRadio", "Calculation must be selected", (value) => value !== "")
      .required("Calculation is required"),
    [`radioCompanyNamesTimeSeries${suffix}`]: yup
      .string()
      .test("is-radioCompanyNamesTimeSeries", "Company must be selected", (value) => value !== "")
      .required("Company is required"),
  });
}

export function getPointInTimeStaticLineDateSchema(baseSchema: yup.ObjectSchema<any>, index: number) {
  const suffix = index > 0 ? index : "";
  return baseSchema.shape({
    ...baseSchema.fields,
    [`staticLineDateInitialInput${suffix}`]: yup
      .string()
      .test("is-InputvalueApprach", "Date cannot be empty", (value) => value !== "")
      .required("Date is required"),
    [`staticLine1Date${suffix}`]: yup
      .string()
      .test("%-Premium", "% Premium cannot be empty", (value) => value !== "")
      .required("Premium to Date is required"),
    [`radioCompanyNamesPointInTime${suffix}`]: yup
      .string()
      .test("is-InputvalueApprach", "Company must be selected", (value) => value !== "")
      .required("Company is required"),
  });
}

export function removeDynamicSchemasUpTo(model: Model, keysToRemove: string[] = []) {
  const currentSchema = model.schema || yup.object().shape({});
  const currentFields = currentSchema.fields || {};

  const newFields = Object.keys(currentFields)
    .filter((key) => !keysToRemove.includes(key))
    .reduce((acc, key) => {
      acc[key] = currentFields[key];
      return acc;
    }, {});

  const newSchema = yup.object(newFields);

  model.setSchema(newSchema);
}
